// extracted by mini-css-extract-plugin
export default {"logo":"logo-sGw1","title":"title-EpCT"};